import axios from 'axios'
import { ACTING_COMMITTEE_HEADER, ACTING_COMMITTEE_STORAGE_KEY } from '@/constants/actingCommittee'

// Stored selection: { id, name } or null
export function getActingCommittee() {
  try {
    return JSON.parse(localStorage.getItem(ACTING_COMMITTEE_STORAGE_KEY) || 'null')
  } catch (_) {
    return null
  }
}

// `axios` here is the plain instance many views use directly; the shared `http` client reads
// the storage on each request (services/api/http.js).
export function syncActingCommitteeHeader() {
  const acting = getActingCommittee()
  if (acting && acting.id) {
    axios.defaults.headers.common[ACTING_COMMITTEE_HEADER] = acting.id
  } else {
    delete axios.defaults.headers.common[ACTING_COMMITTEE_HEADER]
  }
}

export function setActingCommittee(committee) {
  if (committee && committee.id) {
    localStorage.setItem(ACTING_COMMITTEE_STORAGE_KEY, JSON.stringify({ id: committee.id, name: committee.name }))
  } else {
    localStorage.removeItem(ACTING_COMMITTEE_STORAGE_KEY)
  }
  syncActingCommitteeHeader()
}

// Call after every login / login-as / /auth/me: stores the Super Secretary flags and drops a
// selection that belongs to a previous session.
export function storeSuperSecretaryFlags(data, { resetSelection = false } = {}) {
  localStorage.setItem('is_super_secretary', data.is_super_secretary ? 'true' : 'false')
  if (data.own_committee_id) {
    localStorage.setItem('own_committee_id', data.own_committee_id)
  } else {
    localStorage.removeItem('own_committee_id')
  }
  if (resetSelection || !data.is_super_secretary) setActingCommittee(null)
}



// WEBPACK FOOTER //
// ./src/services/actingCommittee.js